import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import NavigationBar from '../../components/ui/NavigationBar';
import ServicesBreadcrumb from '../../components/ui/ServicesBreadcrumb';
import FloatingNavigation from '../../components/ui/FloatingNavigation';
import HeroSection from './components/HeroSection';
import CompanyStorySection from './components/CompanyStorySection';
import TeamSection from './components/TeamSection';
import TestimonialsSection from './components/TestimonialsSection';
import TechnologyPartnersSection from './components/TechnologyPartnersSection';

const AboutPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>About Us - DARAJA.LABS | Digital Transformation Experts</title>
        <meta 
          name="description" 
          content="Learn about DARAJA.LABS - your trusted partner in digital transformation. Meet our expert team, discover our journey, and see why industry leaders choose us for their IT solutions." 
        />
        <meta name="keywords" content="about daraja labs, digital transformation company, IT services team, technology experts, software development company" />
        <meta property="og:title" content="About Us - DARAJA.LABS | Digital Transformation Experts" />
        <meta property="og:description" content="Learn about DARAJA.LABS - your trusted partner in digital transformation. Meet our expert team and discover our journey." />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="/about" />
      </Helmet>
      
      {/* Navigation */}
      <NavigationBar />
      <FloatingNavigation />
      
      {/* Breadcrumb */}
      <div className="pt-16 lg:pt-20">
        <ServicesBreadcrumb 
          serviceCategory="About" 
          serviceName="Company Overview"
        />
      </div>
      
      {/* Main Content */}
      <main className="relative">
        {/* Hero Section */}
        <section id="hero">
          <HeroSection />
        </section>

        {/* Company Story Section */}
        <section id="story">
          <CompanyStorySection />
        </section>

        {/* Team Section */}
        <section id="team">
          <TeamSection />
        </section>

        {/* Testimonials Section */}
        <section id="testimonials">
          <TestimonialsSection />
        </section>

        {/* Technology Partners Section */}
        <section id="partners">
          <TechnologyPartnersSection />
        </section>
      </main>
      
      {/* Footer */}
      <footer className="bg-card border-t border-border py-12 lg:py-16">
        <div className="max-w-7xl mx-auto container-responsive">
          <div className="grid-responsive-4 gap-8 mb-8">
            {/* Company Info */}
            <div className="lg:col-span-2">
              <div className="flex items-center space-x-2 mb-4">
                <div className="w-8 h-8 bg-accent rounded-lg flex items-center justify-center">
                  <span className="text-accent-foreground font-bold text-lg">D</span>
                </div>
                <span className="text-card-foreground font-semibold text-lg">
                  DARAJA.LABS
                </span>
              </div>
              <p className="text-muted-foreground leading-relaxed mb-6 max-w-md">
                Bridging the gap between complex technology and business success through innovative digital transformation solutions.
              </p>
              <div className="flex space-x-4">
                <a href="#" className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center hover:bg-accent/20 transition-colors">
                  <div className="w-5 h-5 bg-accent rounded-full" />
                </a>
                <a href="#" className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center hover:bg-accent/20 transition-colors">
                  <div className="w-5 h-5 bg-accent rounded-full" />
                </a>
                <a href="#" className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center hover:bg-accent/20 transition-colors">
                  <div className="w-5 h-5 bg-accent rounded-full" />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="font-semibold text-card-foreground mb-4">Quick Links</h3>
              <ul className="space-y-2">
                <li><a href="/home" className="text-muted-foreground hover:text-accent transition-colors">Home</a></li>
                <li><a href="/services" className="text-muted-foreground hover:text-accent transition-colors">Services</a></li>
                <li><a href="/about" className="text-muted-foreground hover:text-accent transition-colors">About</a></li>
                <li><a href="/contact" className="text-muted-foreground hover:text-accent transition-colors">Contact</a></li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="font-semibold text-card-foreground mb-4">Contact</h3>
              <ul className="space-y-2 text-muted-foreground">
                <li>info@daraja.com</li>
                <li>+1 240-598-5442</li>
                <li>+254 707 366350</li>
                <li>+231 770066992 WhatsApp Only</li>
                <li>8225 Shooting Star Lane, Laurel, MD 20724</li>
              </ul>
            </div>
          </div>

          {/* Copyright */}
          <div className="border-t border-border pt-8 text-center text-muted-foreground">
            <p>&copy; {new Date()?.getFullYear()} DARAJA.LABS. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AboutPage;